import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  ActionDTO,
  ConditionDTO,
  SceneObjectType,
  TriggerDTO,
} from '@/../client-generator/generated-clients/plants';

import { getSceneObjectIconFromType } from '@/core/utils/utils';
import { SceneUtils } from '@/core/utils/scene.utils';
import SceneTimeObjectInline from '../../../Scene/components/SceneTimeObjectInline/SceneTimeObjectInline.vue';

@Options({
  name: 'SceneListItem',
  props: {
    item: {
      type: Object as PropType<ActionDTO | TriggerDTO | ConditionDTO>,
    },
    reorderable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove', 'edit'],
  components: { SceneTimeObjectInline },
})
export default class SceneListItem extends Vue {
  item!: ActionDTO | TriggerDTO | ConditionDTO;
  reorderable!: boolean;
  getSceneObjectIconFromType = getSceneObjectIconFromType;
  SceneUtils = SceneUtils;
  SceneObjectType = SceneObjectType;

  get objectName() {
    if (this.item.sceneObjectType === SceneObjectType.DateTime) {
      if (this.item instanceof ActionDTO)
        return this.$t('AppResource.WaitingTime');
      else if (this.item instanceof TriggerDTO)
        return this.$t('AppResource.DateAndTime');
      else return this.$t('AppResource.Time');
    } else return this.item.objectName;
  }

  handleAction(
    actionName: string,
    item: ActionDTO | TriggerDTO | ConditionDTO
  ) {
    this.$emit(actionName, item);
  }
}
